import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import UIManifest from "src/engine/ui/UIManifest";

interface IJA extends IBaseUI {
    //地址
    value?: string;
    src?: string;
    errorImage?: string;
    type?: "image" | "bg";
}
interface IState {}

@UIManifest.declareGG(["ggValue"], "JImage", "Image组件", UIManifest.Type.JJ)
class JImage extends BaseUI<IJA, IState> {
    getUrl = () => {
        const { src, value } = this.props;
        return value || src;
    };

    onError = (e: any) => {
        const { errorImage, src } = this.props;
        if (e && e.target) {
            const url = errorImage || src;
            if (url) e.target.src = url;
        }
    };

    render() {
        const { className, type = "image" } = this.props;
        return type === "image" ? (
            <img className={className} style={this.getStyle()} src={this.getUrl()} onError={this.onError} />
        ) : (
            <div style={{ ...this.getStyle(), backgroundImage: `url(${this.getUrl()})` }} />
        );
    }
}

export default JImage;
